<template lang="pug">
  .login
    .login_logo
      <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 449.67 73.5" width=204 height=34>
        <g data-name="cortechne Inc."><g id="cortechne">
          <path class="st0" d="M76.57,23.61a24.95,24.95,0,1,0,24.84,25A24.82,24.82,0,0,0,76.57,23.61Zm0,42.45c-10,0-16.8-7.85-16.8-17.51s6.84-17.5,16.8-17.5,16.79,8,16.79,17.5S86.52,66.06,76.57,66.06Zm189.84-35a16.21,16.21,0,0,1,13.13,6.37l5.4-5.52a24.85,24.85,0,0,0-43.38,16.76,24.9,24.9,0,0,0,43.15,16.88L279.31,60a16.23,16.23,0,0,1-12.9,6c-10,0-16.8-7.85-16.8-17.5S256.45,31.05,266.41,31.05Zm52.47-6.25a20.55,20.55,0,0,0-13.44,4.56V24h-8V72.38h8V48.21c.25-9.62,4.05-16,13.44-16,9.73,0,9.5,9.08,9.5,17V72.38h8V48.32C336.4,35.79,333.58,24.8,318.88,24.8Zm52.67,0a20.55,20.55,0,0,0-13.44,4.56V24h-8.05V72.38h8.05V48.21c.25-9.62,4-16,13.44-16,9.73,0,9.49,9.08,9.49,17V72.38h8V48.32C389.07,35.79,386.24,24.8,371.55,24.8ZM121.31,29.35V24h-8V72.38h8V48.21c.25-9.62,4-16,13.44-16h2.31V24.79h-2.31A20.66,20.66,0,0,0,121.31,29.35Zm27.52,2h8.62v41h8.05v-41h8.62V24H148.83v7.44Zm-124-.34A16.23,16.23,0,0,1,38,37.42l5.4-5.52A24.85,24.85,0,0,0,0,48.66,24.7,24.7,0,0,0,24.84,73.5a24.79,24.79,0,0,0,18.31-8L37.74,60a16.21,16.21,0,0,1-12.9,6c-9.95,0-16.79-7.85-16.79-17.5S14.89,31.05,24.84,31.05Zm182.89-7.44A24.95,24.95,0,1,0,226,65.52L220.63,60a16.21,16.21,0,0,1-12.9,6c-9.95,0-16.79-7.85-16.79-17.5s6.84-17.5,16.79-17.5,16.8,7.94,16.8,17.5c0,.57,0,1.14-.07,1.71h8.06c0-.54.06-1.07.06-1.61A24.82,24.82,0,0,0,207.73,23.61ZM449.61,50.26c0-.53.06-1.06.06-1.61a24.77,24.77,0,1,0-6.56,16.87L437.72,60a16.19,16.19,0,0,1-12.9,6.05c-10,0-16.8-7.85-16.8-17.51s6.84-17.5,16.8-17.5,16.8,8,16.8,17.5c0,.58,0,1.15-.08,1.71Z"></path>
          <path class="st1" d="M297.4,16.5h8V0h-8Zm-139.95,0h8.05V0h-8.05Zm42,33.76H216V43.51H199.48Zm217.09-6.75v6.75h16.5V43.51Z"></path></g></g>
      </svg>
    .login_form
      button.login_button(@click="login")
        img(:src="icon_google")
        span Googleアカウントでログイン

</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  head: {
    title() {
      return {
        inner: 'ログイン',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  data: function(){
    return {
      icon_google: process.env.VUE_APP_PUBLIC_PATH + 'img/google_login.png',
    }
  },
  methods: {
    async login() {
      try{
        const provider = new firebase.auth.GoogleAuthProvider()
        const result = await firebase.auth().signInWithPopup(provider)

        const user = result.user

        // The signed-in user info.
        if( user ) {
          this.$store.dispatch('setIsLoading', true)
        } else {
          this.$common.createErrorMessage(r.errors, "ログインに失敗しました。")
          return
        }

        const idToken = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)

        const data_obj = {
          token: idToken
        }

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res_login = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.LOGIN,
          data_json,
          config
        )

        const r = res_login.data

        if( r.status == 1 ) {
          const user_name = user.displayName
          const user_mail = user.email
          const user_photo_url = user.photoURL

          this.$cookies.set('user_name', user_name)
          this.$cookies.set('user_mail', user_mail)
          this.$cookies.set('user_photo_url', user_photo_url)
          this.$cookies.set('token', r.token)
          this.$cookies.set('role', r.role)

          this.$router.push({ name: "article" })
        } else if ( r.errors[0].status == 500 ) {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            indefinite: true,
            message: 'このGoogleアカウントは登録されていません。<br>アカウント情報に間違いがないかご確認ください。',
            position: 'is-top',
            actionText: 'OK'
          })
        }

      } catch(e) {
        if( e.code === 'auth/cancelled-popup-request' || e.code === 'auth/popup-closed-by-user' ) return
        this.$common.createErrorMessage(null, null)
      } finally {
        this.$store.dispatch('setIsLoading', false)
      }
    },
  }
}
</script>
